import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Amplitude from "@Shared/utils/amplitude";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { mapFields } from "@joandvgv/vuex-map-fields";

// Application
import MainApplicant from "./pages-components/application/main-applicant.vue";
import CoApplicants from "./pages-components/application/co-applicants.vue";
import Property from "./pages-components/application/property.vue";
import MortgageDetails from "./pages-components/application/mortgage-details.vue";
import OtherProperties from "./pages-components/application/other-properties.vue";
import MortgageAndProperty from "./pages-components/application/mortgage-and-property.vue";
import { SAVE_CURRENT_APPLICATION, UPDATE_CUSTOMIZATION_SCHEMA, LOAD_APPLICATION_SYNC_STATUS } from "../store/application-actions";
import { LOAD_FILOGIX_DETAILS, UPDATE_FILOGIX_DETAILS } from "@Broker/@Modules/settings/store/settings-actions";
import Err from "../../../../../routes/error";
import { TOGGLE_FIELD_CUSTOMIZATION, TOGGLE_FIELD_VALIDATION, SET_APPLICATION_SYNC_STATUS } from "../store/application-mutations";
import { difference } from "@Shared/utils/utils";
import { debounce, isEmpty, isUndefined } from "lodash";
import { ARE_FILOGIX_DETAILS_VERIFIED, CURRENT_APPLICATION, IS_CURRENT_USER_APPLICATION_OWNER } from "../store/application-getters";
import { CURRENT_USER_USERNAME } from "@Broker/@Modules/main/store/account/account-getters";
import { GET_FILOGIX_DETAILS } from "@Broker/@Modules/settings/store/settings-getters";
import WidgetEventsMixin from "@Shared/utils/application-mixins/widget-events-mixin";
import LifeInsuranceModal from "./pages-components/application/life-insurance-modal.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationForm",
  components: {
    MainApplicant,
    CoApplicants,
    Property,
    MortgageDetails,
    OtherProperties,
    MortgageAndProperty,
    LifeInsuranceModal
  },
  mixins: [WidgetEventsMixin],
  props: {
    currentPage: {
      type: String,
      required: true
    },
    clientDetails: {
      type: Object,
      default: () => ({})
    },
    editVisibility: {
      type: Boolean,
      default: false
    },
    clientUsername: {
      required: true,
      validator: prop => typeof prop === "string" || prop === null
    },
    applicationId: {
      required: true,
      validator: prop => typeof prop === "number" || prop === null
    },
    agentUsername: {
      required: true,
      validator: prop => typeof prop === "string" || prop === null
    },
    isBrokerage: {
      type: Boolean
    }
  },
  data() {
    return {
      nonce: 1,
      changed: false,
      application: {}
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("ApplicationStore", [ARE_FILOGIX_DETAILS_VERIFIED, IS_CURRENT_USER_APPLICATION_OWNER, CURRENT_APPLICATION])), mapGetters("AccountStore", [CURRENT_USER_USERNAME])), mapFields("ApplicationStore", ["calculatedValues"])), mapGetters("SettingsStore", [GET_FILOGIX_DETAILS])), {}, {
    currentPageComponent() {
      const pageParser = {
        "main-applicant": MainApplicant,
        "co-applicants": CoApplicants,
        property: MortgageAndProperty,
        "mortgage-details": MortgageAndProperty,
        "other-properties": OtherProperties
      };
      return pageParser[this.currentPage];
    },
    directToLenderPages() {
      return ["credit-bureau", "fees", "commissions", "lender-response", "lender-submit", "participants", "internal-notes", "forms"];
    },
    isApplication() {
      const notApplication = ["filogix", "documents", ...this.directToLenderPages];
      return !_includesInstanceProperty(notApplication).call(notApplication, this.currentPage);
    },
    isDirectToLenderPage() {
      var _context;
      return _includesInstanceProperty(_context = this.directToLenderPages).call(_context, this.currentPage);
    },
    isApplicationOwner() {
      return this.IS_CURRENT_USER_APPLICATION_OWNER({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername
      });
    },
    filogixDetails() {
      return this.GET_FILOGIX_DETAILS;
    }
  }),
  watch: {
    currentPage() {
      if (this.isDirectToLenderPage && !this.filogixDetails.expertLodingId) {
        this.LOAD_FILOGIX_DETAILS();
      }
    }
  },
  mounted() {
    this.setCloseWidgetOnExit(false);
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("ApplicationStore", [SAVE_CURRENT_APPLICATION, UPDATE_CUSTOMIZATION_SCHEMA, LOAD_APPLICATION_SYNC_STATUS])), mapActions("SettingsStore", [LOAD_FILOGIX_DETAILS, UPDATE_FILOGIX_DETAILS])), {}, {
    onBeforeUnload() {
      this.confirmExit();
    },
    confirmExit(event) {
      if (!this.isApplication) return;
      const differences = difference(this.CURRENT_APPLICATION, this.application);
      const saving = this.CURRENT_APPLICATION.saving;
      delete differences.saving;
      delete differences.updatedAt;
      const confirm = saving || this.changed && !isEmpty(differences);
      if (confirm) {
        const confirmationMessage = this.$t("global.phrases.youHaveUnsavedChanges");
        event.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
        return confirmationMessage; // Gecko, WebKit, Chrome <34
      }
    },
    handlePageChange(page, opts) {
      this.$emit("page-change", page, opts);
    }
  }, mapMutations("ApplicationStore", [TOGGLE_FIELD_CUSTOMIZATION, TOGGLE_FIELD_VALIDATION, SET_APPLICATION_SYNC_STATUS])), {}, {
    getOtherPropertiesVisibilityPaths(paths) {
      const pathsWithOtherProperties = _filterInstanceProperty(paths).call(paths, path => _includesInstanceProperty(path).call(path, "other-properties"));
      return _reduceInstanceProperty(pathsWithOtherProperties).call(pathsWithOtherProperties, (pathsForBothApplicants, path) => {
        const coApplicantsPath = path.replace("main-applicant", "co-applicants");
        pathsForBothApplicants.push(path, coApplicantsPath);
        return pathsForBothApplicants;
      }, []);
    },
    handleVisibility({
      paths,
      isVisible,
      isRequired,
      multi
    }) {
      if (!isUndefined(isVisible) && !isUndefined(isRequired)) return;
      let pathsToUse = paths;
      if (paths.some(path => _includesInstanceProperty(path).call(path, "other-properties"))) {
        pathsToUse = this.getOtherPropertiesVisibilityPaths(paths);
      }
      const customization = !isUndefined(isVisible) ? "visible" : "required";
      this.TOGGLE_FIELD_CUSTOMIZATION({
        paths: pathsToUse,
        customization,
        multi,
        isVisible
      });
      return this.UPDATE_CUSTOMIZATION_SCHEMA({
        isBrokerage: this.isBrokerage
      });
    },
    fireSave() {
      this.SAVE_CURRENT_APPLICATION({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername,
        reFetchCalculations: true
      }).then(() => {
        this.application = this.CURRENT_APPLICATION;
        this.sendWidgetMessage("validation-rules", "refresh");
        this.sendWidgetMessage("calculation-explanations", "refresh");
      }).catch(e => {
        Amplitude.logHandledError(e, {
          applicationId: this.applicationId,
          clientUsername: this.clientUsername
        });
        Err.handle(e);
      });
      this.$root.$emit("update-sync-status", {
        startImmediately: true
      });
    },
    saveApplication: debounce(function () {
      this.fireSave();
    }, 300),
    async saveOnType() {
      if (!this.isApplication) return;
      this.changed = true;
      this.saveApplication();
      this.sendWidgetMessage("validation-rules", "pre-fetch");
    },
    handleSubmit() {
      this.saveOnType();
    },
    handleRefresh() {
      this.nonce += 1;
    },
    handleOpenLifeInsuranceModal() {
      this.$refs.lifeInsuranceModal.handleShow();
    }
  })
});